import { DestinationClient } from '@/scopes/destinations/domain/types/destinationDataClient'
import { createDestionationResponseMapper, DestinationResponseMapper } from '@/scopes/destinations/infrastructure/api/destinationResponseMapper'
import defaultFetch from 'isomorphic-unfetch'

interface Dependencies {
  contextItemId: string
  datasourceId: string
  env: {
    NEXT_PUBLIC_API_BASE_URL: string
  }
  fetch: typeof defaultFetch
  destinationResponseMapper: DestinationResponseMapper
}

export function createDestinationClient(dependencies: Partial<Dependencies> = {}): DestinationClient {
  const {
    contextItemId,
    datasourceId,
    env = {
      NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    },
    fetch = defaultFetch,
    destinationResponseMapper = createDestionationResponseMapper(),
  } = dependencies

  async function getSelectorOptions() {
    const url = `${env.NEXT_PUBLIC_API_BASE_URL}/DestinationSelector/GetSelectorsAPI?contextItemId=${contextItemId}&datasourceId=${datasourceId}`
    const response = await fetch(url)

    if (!response.ok) {
      throw new Error(`Failed to fetch destination selector options: ${response.statusText}`)
    }
    const result = await response.json()
    return destinationResponseMapper.map(result)
  }

  return {
    getSelectorOptions,
  }
}
